import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAudioUrl,
  resetTaskVariable,
} from "store/bailiff/task/dialog/draft_dialog.action";
import { draftDialogDetailSelector } from "store/bailiff/task/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
export const TriggerUrl = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const detail = useSelector(draftDialogDetailSelector);
  const part = detail?.slot;
  const bailiff = detail?.bailiff;

  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (part && bailiff) {
      dispatch(getAudioUrl({ bailiff, part }));
    }
  }, [dispatch, part, bailiff]);

  //reset
  useEffect(() => {
    dispatch(resetTaskVariable());
  }, [dispatch, bailiff]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerUrl;
